import React, { useState } from 'react';
import { Col, Form, Row } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import TextInput from "../components_parts/TextInput";
import Help from "../../buttons/Help";
import { Collapse } from "react-bootstrap";
const assignmentHelp = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", null, "An assignment of individual variables (i.e., a partial map from individual variables to the domain\xA0\uD835\uDC37) is defined in this section."), /*#__PURE__*/React.createElement("p", null, "Any alphanumeric symbol that is not an individual constant, predicate, or function symbol is considered a variable."), /*#__PURE__*/React.createElement("p", {
  className: "mb-0"
}, "Elements of the assignment are comma-separated ordered pairs. Each pair can be written as ", /*#__PURE__*/React.createElement("code", null, "(variable, element)"), "or ", /*#__PURE__*/React.createElement("code", null, "variable \u21A6 element"), ". The maps-to symbol\xA0", /*#__PURE__*/React.createElement("code", null, "\u21A6"), " can also be written as", " ", /*#__PURE__*/React.createElement("code", null, "->"), ", ", /*#__PURE__*/React.createElement("code", null, "|->"), ", ", /*#__PURE__*/React.createElement("code", null, "\\mapsto"), ", or\xA0", /*#__PURE__*/React.createElement("code", null, "\u27FC"), "."));

const VariablesValue = props => {
  const [showHelp, setShowHelp] = useState(false);
  return /*#__PURE__*/React.createElement(Card, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Card.Header, {
    as: "h5",
    className: "d-flex justify-content-between"
  }, /*#__PURE__*/React.createElement("span", null, "Variable assignment"), /*#__PURE__*/React.createElement(Help, {
    subject: "language",
    children: assignmentHelp,
    onToggle: setShowHelp,
    show: showHelp
  })), /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    lg: 12
  }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, "Assignment of individual variables"), /*#__PURE__*/React.createElement(TextInput, {
    errorProperty: props.variables.errorMessage,
    onChange: e => props.onInputChange(e.target.value),
    onLock: () => props.lockInput(),
    textData: props.variables,
    label: /*#__PURE__*/React.createElement("span", null, "\uD835\uDC52 = {"),
    teacherMode: props.teacherMode,
    id: "editor-variables"
  }))))));
};

export default VariablesValue;